export const WITHDRAWAL_DEEPLINK_QUERY_PARAMS = {
  CURRENCY: 'currency',
  APP_ID: 'app_id',
};

export const WITHDRAWAL_DEEPLINK_SESSION_KEYS = {
  RETURN_URL: 'withdrawal_deeplink.returnUrl',
};
